import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import MyRouteMiddleware from "./middleware/auth/authValidRoute";

import { dispatchRoutes } from "./dispatchRoutes";
import { factoryRoutes } from "./factoryRoutes";
import { groupedVeneerRoutes } from "./groupedVeneerRoutes";
import { groupingRoutes } from "./groupingRoutes";
import { masterRoutes } from "./masterRoutes";
import { orderRoutes } from "./orderRoute";
import { otherGoodsRoutes } from "./otherGoodsRoutes";
import { readyForDispatchRoutes } from "./readyForDispatchRoutes";
import { readySheetFormRoute } from "./readysheetform";
import userManagementRoutes from "./userManagementRoutes";
import { rawMaterialRoute } from "./rawMaterialRoutes";

// ✅ Lazy load pages
const Login = lazy(() => import("app/pages/login"));
const Dashboard = lazy(() => import("app/pages/Dashboard"));
const ForgotPassword = lazy(() => import("app/pages/ForgotPassword"));
const PasswordOtp = lazy(() => import("app/pages/Otp"));
const EditUserProfile = lazy(() => import("app/pages/UserManagement/Edit Profile"));

/**
 * Routes which you want to make accessible to both authenticated and anonymous users
 */
const routesForPublic = [
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Page component={Login} layout={"solo-page"} />
      </Suspense>
    ),
  },
  {
    path: "/user/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Page component={Login} layout={"solo-page"} />
      </Suspense>
    ),
  },
  {
    path: "/password/reset",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Page component={ForgotPassword} layout={"solo-page"} />
      </Suspense>
    ),
  },
  {
    path: "/password/otp",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Page component={PasswordOtp} layout={"solo-page"} />
      </Suspense>
    ),
  },
  {
    middleware: [
      {
        element: MyRouteMiddleware,
        fallbackPath: "/user/login",
      },
    ],
    routes: [
      {
        path: "/profile",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={EditUserProfile} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={Dashboard} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      ...userManagementRoutes,
      ...masterRoutes,
      ...rawMaterialRoute,
      ...otherGoodsRoutes,
      ...groupingRoutes,
      ...groupedVeneerRoutes,
      ...factoryRoutes,
      ...readySheetFormRoute,
      ...orderRoutes,
      ...readyForDispatchRoutes,
      ...dispatchRoutes,
    ],
  },
];

/**
 * Routes only accessible to authenticated users
 */
const routesForAuthenticatedOnly = [];

/**
 * Routes only accessible when user is anonymous
 */
const routesForNotAuthenticatedOnly = [];

const routes = [...routesForPublic, ...routesForAuthenticatedOnly, ...routesForNotAuthenticatedOnly];

export { routes as default, routesForAuthenticatedOnly, routesForNotAuthenticatedOnly, routesForPublic };
